export enum STTProvider {
	DEEPGRAM = 'deepgram',
	DEEPGRAM_FLUX = 'deepgram-flux',
	ASSEMBLYAI = 'assemblyai',
	ELEVENLABS = 'elevenlabs',
}

export interface STTModelOption {
	value: string;
	label: string;
}

export const STT_MODELS: Record<STTProvider, STTModelOption[]> = {
	[STTProvider.DEEPGRAM]: [
		{ value: 'nova-3-general', label: 'Nova 3 General (Multi-language)' },
		{ value: 'nova-2', label: 'Nova 2 (Legacy)' },
		{ value: 'nova-2-general', label: 'Nova 2 General' },
		{ value: 'nova-2-meeting', label: 'Nova 2 Meeting' },
		{ value: 'nova-2-phonecall', label: 'Nova 2 Phone Call' },
		{ value: 'nova-2-voicemail', label: 'Nova 2 Voicemail' },
		{ value: 'nova-2-finance', label: 'Nova 2 Finance' },
		{ value: 'nova-2-conversationalai', label: 'Nova 2 Conversational AI' },
		{ value: 'nova-2-video', label: 'Nova 2 Video' },
		{ value: 'nova-2-medical', label: 'Nova 2 Medical' },
		{ value: 'nova-2-drivethru', label: 'Nova 2 Drive-thru' },
		{ value: 'nova-2-automotive', label: 'Nova 2 Automotive' },
	],
	[STTProvider.DEEPGRAM_FLUX]: [
		{ value: 'flux-general-en', label: 'Flux General (English)' },
	],
	[STTProvider.ASSEMBLYAI]: [{ value: 'universal', label: 'Universal Model' }],
	[STTProvider.ELEVENLABS]: [
		{ value: 'scribe_v2_realtime', label: 'Scribe v2 (Realtime)' },
	],
};

export const DEFAULT_STT_MODELS: Record<STTProvider, string> = {
	[STTProvider.DEEPGRAM]: 'nova-3-general',
	[STTProvider.DEEPGRAM_FLUX]: 'flux-general-en',
	[STTProvider.ASSEMBLYAI]: 'universal',
	[STTProvider.ELEVENLABS]: 'scribe_v2_realtime',
};
